import CartCard from './CartCard'
import AdminStatusMark from './AdminStatusMark'
import { ShieldGlyph } from './AdminIcons'
import {
  accountStatusLabel,
  adminDisplayName,
  adminInitials,
  articlesCountLabel,
  formatStamp,
  missingOrError,
  presenceHint,
  presenceLabel,
  resetOutcomeText,
  roleLabel,
} from '../utils/adminPolicy'
import { formatEuroFr } from '../utils/editProductOutcome'

export default function AdminUserWorkspace({
  detail,
  carts = [],
  cartsError = false,
  resetNotice,
  resetPending,
  onReset,
  onOpenCart,
  onCopyId,
  copied,
  onBack,
}) {
  if (!detail) {
    return <p className="admin-state">Fiche utilisateur indisponible.</p>
  }
  const presence = detail.presence || 'unknown'
  return (
    <div className="admin-workspace">
      <div className="admin-workspace-nav">
        <button type="button" className="admin-back" onClick={onBack}>
          <img src="/Icon arrow back ios new.png" alt="" />
          Retour à la liste
        </button>
      </div>

      <header className="admin-workspace-hero">
        {detail.avatar_url ? (
          <img src={detail.avatar_url} alt="" className="admin-avatar admin-avatar--lg" />
        ) : (
          <span className="admin-avatar admin-avatar--lg admin-avatar--fallback" aria-hidden="true">
            {adminInitials(detail)}
          </span>
        )}
        <div className="admin-workspace-identity">
          <p className="admin-kicker">
            <ShieldGlyph />
            <span>Administration</span>
          </p>
          <h2 id="admin-user-title">{adminDisplayName(detail)}</h2>
          <p className="admin-file-email">{detail.email || 'Adresse absente'}</p>
          <div className="admin-workspace-marks">
            <AdminStatusMark kind={detail.role === 'admin' ? 'admin' : 'member'} label={roleLabel(detail.role)} />
            <AdminStatusMark kind={detail.account_status || 'unknown'} label={accountStatusLabel(detail.account_status)} />
            <AdminStatusMark
              kind={presence}
              label={presenceLabel(presence)}
              title={presenceHint(presence, detail.presence_freshness_seconds)}
            />
          </div>
        </div>
        <button type="button" className="admin-workspace-reset" onClick={onReset} disabled={resetPending}>
          Envoyer un e-mail de réinitialisation
        </button>
      </header>
      {resetNotice ? <p className="admin-notice">{resetOutcomeText(resetNotice)}</p> : null}

      <dl className="admin-workspace-facts">
        <div>
          <dt>Création</dt>
          <dd>{formatStamp(detail.created_at, 'Date de création indisponible')}</dd>
        </div>
        <div>
          <dt>Dernière connexion</dt>
          <dd>{formatStamp(detail.last_login_at || detail.last_sign_in_at, 'Aucune connexion enregistrée')}</dd>
        </div>
        <div>
          <dt>Dernière activité</dt>
          <dd>{formatStamp(detail.last_activity_at, 'Aucune activité enregistrée')}</dd>
        </div>
        <div>
          <dt>Identifiant</dt>
          <dd>
            <code>{detail.id}</code>
            <button type="button" className="admin-copy" onClick={() => onCopyId(detail.id)}>
              {copied ? 'Copié' : 'Copier'}
            </button>
          </dd>
        </div>
      </dl>

      <section className="admin-workspace-carts">
        <div className="admin-section-head">
          <h3>Paniers</h3>
          <p>{missingOrError(detail.carts_count, detail.counts_error)} · {articlesCountLabel(detail.items_count, detail.counts_error)}</p>
        </div>
        {cartsError ? <p className="admin-state">Impossible de charger les paniers.</p> : null}
        {!cartsError && !carts.length ? <p className="admin-state">Aucun panier accessible.</p> : null}
        {!cartsError && carts.length ? (
          <div className="carts-grid">
            {carts.map((cart) => (
              <CartCard
                key={cart.id}
                cart={cart}
                subtitle={articlesCountLabel(cart.items_count)}
                totalLabel={`Total estimé : ${formatEuroFr(cart.total)}`}
                onClick={() => onOpenCart(cart.id)}
              />
            ))}
          </div>
        ) : null}
      </section>
    </div>
  )
}
